import { Component, Inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyService } from 'src/app/core/services/company.service';
import { MODAL_DATA } from 'src/app/core/services/modal';
import { HeaderService } from 'src/app/core/services/header.service';
import { SnotifyService } from 'ng-snotify';
import { environment } from 'src/environments/environment';
import { BetaFeatureAcceptanceStatus } from 'src/app/core/infrastructure/enums/beta-feature-acceptance.enum';

interface ModalData {
  title:string;
  featureKey: string;
  descriptionHtml: string;
}

@Component({
  selector: 'app-beta-feature',
  templateUrl: './beta-feature.component.html',
  styleUrls: ['./beta-feature.component.scss']
})
export class BetaFeatureComponent {

  constructor(
    @Inject(MODAL_DATA) public data: ModalData,
    public activeModal: NgbActiveModal,
    private companyService: CompanyService,
    private headerService: HeaderService,
    private snotifyService: SnotifyService
  ) {}

  get title():string{
    return this.data?.title;
  }

  get enableFeatureRequestLink(): string {
    return environment.betaNewFeature.enableFeatureRequestLink;
  }

  get descriptionHtml(): string {
    return this.data?.descriptionHtml || '';
  }

  /**
   * Saves the user's Accept/Decline decision for beta features.
   */
  saveBetaState(featureKey: string, isAccept: BetaFeatureAcceptanceStatus): void {
    const currentCompany = this.companyService.currentCompany();
    
    if (currentCompany) {
      // 1. Update disclaimer acceptance state (true = Accept, false = Decline)
      const updatedState = { ...(currentCompany.betaFeatureDisclamerAcceptance || {}) };
      updatedState[featureKey] = isAccept;

      currentCompany.betaFeatureDisclamerAcceptance = updatedState;
      
      // 2. Instantly refresh the navigation sidebar to hide/show the feature
      this.headerService.sendCompany(currentCompany);

      // 3. Save updates to database
      this.companyService.updateCompanyInfo({
        companyKey: currentCompany.companyKey,
        companyType: currentCompany.companyType,
        betaFeatureDisclamerAcceptance: updatedState,
        featureOnboardingState: currentCompany.featureOnboardingState,
        displayAdvertisingAMZ: currentCompany.displayAdvertisingAMZ,
        displayItemsRepricingAMZ: currentCompany.displayItemsRepricingAMZ
      }).subscribe();
    }
  }

  onConfirm(): void {
    this.saveBetaState(this.data.featureKey, BetaFeatureAcceptanceStatus.CONFIRMED);
    this.snotifyService.success("This feature is enabled.");
    this.activeModal.close(true);
  }

  onDecline(): void {
    this.activeModal.close(false);
  }
  
  onDismiss():void{
    this.activeModal.close(false);
  }
}